import React from 'react'
import './about.css'
import me from './a37oR.gif'

const about = () => {
  return (
  <section id='details'>
    <div className='about' id="about">
      <h1 className='first'>About</h1>
      <img className='Image' src={me} alt="Pratham Kandari" />
      <div className='para'>I am a Third year student currently pursuing my BTech in Computer Science and Engineering in Cloud Computing in Virtualization and Technology as Specialization from The University of Petroleum and Energy Studies and my current CGPA is 8.06. I am from Uttarakhand, Dehradun and my hobbies include watching movies, playing Badminton and improve my Technical Skills. I am currently a Technical Head at UPES-CSI(Computer Society of India) and its been more than one year. I am a Student Placement Representative at my college. I was appointed as the group leader during my Social Internship at Building Dreams Foundation which helped me in Communication skills and Leadership qualities. </div>
    </div>
    </section>
  )
}

export default about